import React from "react"
import footerStyles from "./footer.module.css"

export default props => <div className={footerStyles.container}>&copy; 2024 - Tutti i diritti riservati - Bernasconi SA </div>
